import { type FC } from 'react';
import {
  ArrowsLeftRight
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconArrowsLeftRightProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconArrowsLeftRight: FC<UiIconArrowsLeftRightProps> = (props) => {
  return (
    <UiIcon
      IconComponent={ArrowsLeftRight}
      {...props}
    />
  );
};
